import { jsxs as D, jsx as f } from "react/jsx-runtime";
import { clsx as h } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { useState as M, useRef as m } from "react";
import { getRovingIndex as I } from "../../utils/roving-index.js";
import { scrollElementIntoViewVertically as q } from "../../utils/scroll-element-into-view-vertically.js";
import { useHorizontalScrollIntoView as F } from "../../utils/use-horizontal-scroll-into-view.js";
import { useIsDocumentRTL as G } from "../../utils/use-rtl-direction.js";
import { useScrollActiveItemIntoViewOnMount as J } from "../../utils/use-scroll-active-item-into-view-on-mount.js";
import { useScrollBlur as P } from "../../utils/use-scroll-blur.js";
import { RocheUIIcon as L } from "../icon/roche-icon.js";
import n from "./roche-tabs.module.scss.js";
const E = (u) => `tab-${u}`, Q = (u, l) => l === void 0 || l < 0 || l >= ((u == null ? void 0 : u.length) ?? 0) ? 0 : l, it = ({
  initiallySelected: u,
  appearance: l = "default",
  autoScroll: S = !0,
  centered: H = !1,
  hasMarginTop: T = !0,
  tabs: o,
  children: v,
  slot: W,
  onTabClick: R,
  activeTabId: y,
  scrollActiveTabIntoViewOnMount: $ = !1,
  scrollPageToActiveTabOnMount: j = !1
}) => {
  const a = G(), N = y !== void 0, [k, C] = M(
    () => Q(o, u)
  ), x = (o == null ? void 0 : o.findIndex((r) => r.id === y)) ?? -1, s = N && x >= 0 ? x : k, d = m([]), B = m(null), g = m(null), V = m(null), b = m(null), p = P(g), { scrollIntoView: w } = F(d, g, {
    leftInsetRef: V,
    rightInsetRef: b
  });
  J($ && S, () => {
    if (w(s), j) {
      const r = d.current[s];
      r && q(r);
    }
  });
  const K = (r) => {
    N || C(r);
  }, O = (r, t) => {
    const e = o == null ? void 0 : o[t], c = (e == null ? void 0 : e.headline) || "", i = (e == null ? void 0 : e.id) || "";
    R == null || R(r, c, i), t !== s && (K(t), w(t));
  }, U = (r) => {
    var _;
    if (!o || o.length === 0 || !r.key)
      return;
    const { key: t } = r, e = () => d.current.indexOf(document.activeElement), c = {
      ArrowRight: () => I(a ? "previous" : "next", e(), o.length),
      ArrowLeft: () => I(a ? "next" : "previous", e(), o.length),
      Home: () => I("first", e(), o.length),
      End: () => I("last", e(), o.length)
    };
    if (!c[t])
      return;
    r.preventDefault();
    const i = c[t]();
    i !== e() && ((_ = d.current[i]) == null || _.focus(), w(i));
  }, A = (r) => {
    const t = B.current, e = g.current;
    if (!e || !t || Array.from(e.children).length === 0)
      return;
    const i = ((t == null ? void 0 : t.offsetWidth) ?? 0) * 0.8, _ = r === "right" ? i : -i;
    e.scrollBy({
      left: _,
      behavior: "smooth"
    });
  }, z = h(n.tabs, {
    [n["tabs--centered"]]: H,
    [n["tabs--no-margin"]]: !T,
    [n["tabs--filter"]]: l === "filter" || l === "filter-grey",
    [n["tabs--filter-grey"]]: l === "filter-grey",
    [n["tabs--light"]]: l === "light"
  });
  return /* @__PURE__ */ D("div", { className: z, slot: W, children: [
    /* @__PURE__ */ D("div", { className: n["tabs__tab-list-wrapper"], ref: B, children: [
      (p === "left" || p === "both") && /* @__PURE__ */ f(
        "div",
        {
          className: h(n["tabs__scroll-button"], n["tabs__scroll-button--left"]),
          onClick: () => A("left"),
          ref: V,
          children: /* @__PURE__ */ f(L, { icon: a ? "chevron-right" : "chevron-left", height: "24px" })
        }
      ),
      /* @__PURE__ */ f("div", { className: n["tabs__tab-list"], role: "tablist", ref: g, children: o == null ? void 0 : o.map((r, t) => /* @__PURE__ */ f(
        "button",
        {
          className: h(n.tabs__tab, s === t && n["tabs__tab--active"]),
          id: E(r.id),
          type: "button",
          role: "tab",
          "aria-selected": s === t,
          "aria-controls": `panel-${r.id}`,
          tabIndex: s === t ? 0 : -1,
          onClick: (e) => O(e, t),
          onKeyDown: U,
          ref: (e) => {
            d.current[t] = e;
          },
          children: /* @__PURE__ */ f("span", { id: r.id, className: n["tabs__tab-label"], children: r.headline })
        },
        r.id
      )) }),
      (p === "right" || p === "both") && /* @__PURE__ */ f(
        "div",
        {
          className: h(n["tabs__scroll-button"], n["tabs__scroll-button--right"]),
          onClick: () => A("right"),
          ref: b,
          children: /* @__PURE__ */ f(L, { icon: a ? "chevron-left" : "chevron-right", height: "24px" })
        }
      )
    ] }),
    v == null ? void 0 : v.map((r, t) => {
      var e, c;
      return /* @__PURE__ */ f(
        "div",
        {
          className: h(n.tabs__panel, s === t && n["tabs__panel--active"]),
          id: `panel-${(e = o == null ? void 0 : o[t]) == null ? void 0 : e.id}`,
          role: "tabpanel",
          "aria-labelledby": E((c = o == null ? void 0 : o[t]) == null ? void 0 : c.id),
          hidden: s !== t,
          children: r
        },
        t
      );
    })
  ] });
};
export {
  it as RocheUITabs
};
